import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Modal,
  Typography,
  Paper,
} from "@mui/material";

import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
const BASE_URL = process.env.REACT_APP_BASE_URL;

const CoordinatorGuestList = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const id = location.state?.id;
  const [showForm, setShowForm] = useState(false); // Controls whether the form is displayed
  const [selectedGuest, setSelectedGuest] = useState(null); // For modal details
  const [guestData, setGuestData] = useState(null); // Store Guest Form data

 

  const handleViewDetails = (guest) => {
    setSelectedGuest(guest);
  };

  const handleCloseModal = () => {
    setSelectedGuest(null);
  };

  useEffect(() => {
    async function FetchData() {
      try {
        const res = await axios.get(
          `${BASE_URL}/api/v1/User/Guest_List/${id}`
        );

        console.log(res);
        setGuestData(res.data.guests);
      } catch (error) {}
    }
    FetchData();
  }, []);

  const HandleBack = () => {
    navigate("/co-ordinator-dashboard/User-InQuiry");
  };
  const DownloadCSV = (data, filename = "guest_list.csv") => {
    if (!data || data.length === 0) {
      alert("No data available to download!");
      return;
    }
  
    // Extract headers (column names)
    const headers = [
      "Guest ID",
      "User ID",
      "Guest Name",
      "Age",
      "Gender",
      "Relationship",
      "Contact",
      "Email",
      "Total People",
      "Onward From",
      "Onward To",
      "Onward Mode",
      "Onward Date",
      "Onward Start Time",
      "Onward Arrival Time",
      "Return From",
      "Return To",
      "Return Mode",
      "Return Date",
      "Return Start Time",
      "Return Arrival Time",
      "Family Members"
    ].join(",");
  
    // Convert data rows
    const rows = data.map((guest) => {
      return [
        guest.guest_id,
        guest.userId,
        guest.guest_name,
        guest.age,
        guest.gender,
        guest.relationship,
        guest.contact,
        guest.email,
        guest.total_people,
        guest.onward_journey.placeFrom,
        guest.onward_journey.placeTo,
        guest.onward_journey.modeOfTravel,
        guest.onward_journey.journeyStartDate,
        guest.onward_journey.journeyStartTime,
        guest.onward_journey.arrivalTime,
        guest.return_journey.placeFrom,
        guest.return_journey.placeTo,
        guest.return_journey.modeOfTravel,
        guest.return_journey.journeyStartDate,
        guest.return_journey.journeyStartTime,
        guest.return_journey.arrivalTime,
        guest.family_members.length > 0
          ? guest.family_members.map(f => `${f.name} (${f.relationship})`).join(" | ")
          : "No Family Members"
      ].map(value => `"${value}"`).join(","); // Handle commas inside values
    });
  
    // Merge headers and rows
    const csvContent = [headers, ...rows].join("\n");
  
    // Create a Blob and trigger download
    const blob = new Blob([csvContent], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
  
    // Cleanup
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };
  

  return (
    <Box sx={{ margin: "80px" }}>
      <Button
        variant="contained"
        color="secondary"
        onClick={HandleBack}
        sx={{ position: "absolute", top: "20px", left: "20px" }}
      >
        Back
      </Button>
      {/* Toggle between Guest Form and Table */}
      {/* <Button
        variant="contained"
        color="primary"
        onClick={() => setShowForm(!showForm)}
        sx={{ float: "right", marginBottom: 2 }}
      >
        {showForm ? "Back to Guest List" : "Guest Form"}
      </Button> */}

      {/* Conditional Rendering */}
      <Typography
        variant="h2"
        className="text-center "
        sx={{
          fontFamily: "Satisfy, cursive",
          fontWeight: 700,
          display: "flex",
          alignItems: "center",
        }}
        gutterBottom
      >
        Guest List
      </Typography>
      <Button
  variant="contained"
  sx={{ 
    backgroundColor: "green", // ✅ Green color
    color: "white", // ✅ White text for contrast
    fontSize: "1.0rem", // ✅ Increased font size
    position: "absolute", 
    top: "100px", 
    right: "160px",
    padding:"5px 16px",
    "&:hover": { backgroundColor: "darkgreen" }, // ✅ Darker green on hover
  }}
  onClick={()=>DownloadCSV(guestData)}
>
Download CSV
</Button>


      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell style={{ fontSize: "1.5rem" }}>ID</TableCell>
              <TableCell style={{ fontSize: "1.5rem" }}>Guest Name</TableCell>
              <TableCell style={{ fontSize: "1.5rem" }}>
                No. of Family Members
              </TableCell>
              <TableCell style={{ fontSize: "1.5rem" }}>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {guestData &&
              guestData.map((guest) => (
                <TableRow key={guest.guest_id}>
                  <TableCell style={{ fontSize: "1.2rem" }}>
                    {guest.guest_id}
                  </TableCell>
                  <TableCell style={{ fontSize: "1.2rem" }}>
                    {guest.guest_name}
                  </TableCell>
                  <TableCell style={{ fontSize: "1.2rem" }}>
                    {guest.family_members?.length || 0}
                  </TableCell>
                  <TableCell>
                    <Button
                      variant="outlined"
                      onClick={() => handleViewDetails(guest)}
                    >
                      View
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Modal for Viewing Guest Details */}
      <Modal open={!!selectedGuest} onClose={handleCloseModal}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 500,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            borderRadius: "8px",
          }}
        >
          {selectedGuest && (
            <>
              {/* Guest Details */}
              <Typography
                variant="h5"
                gutterBottom
                sx={{
                  fontWeight: "bold",
                  color: "#1976d2",
                  fontFamily: "KaushanScript",
                }}
              >
                Guest Details
              </Typography>
              <Box sx={{ pl: 2 }}>
                <Typography>
                  <strong>Name:</strong> {selectedGuest.guest_name}
                </Typography>
                <Typography>
                  <strong>Age:</strong> {selectedGuest.age}
                </Typography>
                <Typography>
                  <strong>Gender:</strong> {selectedGuest.gender}
                </Typography>
                <Typography>
                  <strong>Contact:</strong> {selectedGuest.contact}
                </Typography>
                <Typography>
                  <strong>Email:</strong> {selectedGuest.email}
                </Typography>
              </Box>

              {/* Family Members Section */}
              {/* {selectedGuest.family_members?.length > 0 && (
              <>
                <Typography variant="h5" gutterBottom sx={{ fontWeight: "bold", color: "#1976d2", fontFamily: "KaushanScript" }}>
                  Family Members
                </Typography>
                
                {selectedGuest.family_members.map((member, index) => (
                  <Accordion key={index}>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                      <Typography variant="h6">{member.name}</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography><strong>Age:</strong> {member.age}</Typography>
                      <Typography><strong>Gender:</strong> {member.gender}</Typography>
                      <Typography><strong>Relationship:</strong> {member.relationship}</Typography>
                      <Typography><strong>Contact:</strong> {member.contact}</Typography>
                      <Typography><strong>Email:</strong> {member.email}</Typography>
                    </AccordionDetails>
                  </Accordion>
                ))}
              </>
            )} */}

              <TableContainer
                component={Paper}
                sx={{ boxShadow: 3, borderRadius: "6px", marginTop: "20px" }}
              >
                <Table>
                  <TableHead>
                    <TableRow sx={{ backgroundColor: "#1976d2" }}>
                      <TableCell
                        sx={{
                          color: "white",
                          fontSize: "1rem",
                          fontWeight: "bold",
                          padding: "10px",
                        }}
                      >
                        Name
                      </TableCell>
                      <TableCell
                        sx={{
                          color: "white",
                          fontSize: "1rem",
                          fontWeight: "bold",
                          padding: "10px",
                        }}
                      >
                        Age
                      </TableCell>
                      <TableCell
                        sx={{
                          color: "white",
                          fontSize: "1rem",
                          fontWeight: "bold",
                          padding: "10px",
                        }}
                      >
                        Gender
                      </TableCell>
                      <TableCell
                        sx={{
                          color: "white",
                          fontSize: "1rem",
                          fontWeight: "bold",
                          padding: "10px",
                        }}
                      >
                        Relationship
                      </TableCell>
                      <TableCell
                        sx={{
                          color: "white",
                          fontSize: "1rem",
                          fontWeight: "bold",
                          padding: "10px",
                        }}
                      >
                        Contact
                      </TableCell>
                      <TableCell
                        sx={{
                          color: "white",
                          fontSize: "1rem",
                          fontWeight: "bold",
                          padding: "10px",
                        }}
                      >
                        Email
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {selectedGuest.family_members?.length > 0 ? (
                      selectedGuest.family_members.map((member, index) => (
                        <TableRow
                          key={index}
                          sx={{
                            "&:nth-of-type(odd)": {
                              backgroundColor: "#f9f9f9",
                            },
                          }}
                        >
                          <TableCell>{member.name}</TableCell>
                          <TableCell>{member.age}</TableCell>
                          <TableCell>{member.gender}</TableCell>
                          <TableCell>{member.relationship}</TableCell>
                          <TableCell>{member.contact}</TableCell>
                          <TableCell>{member.email}</TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell
                          colSpan={6}
                          sx={{
                            textAlign: "center",
                            fontWeight: "bold",
                            color: "#d32f2f",
                          }}
                        >
                          No Family Members Found
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
              {/* Travel Plan */}
              <Typography
                variant="h6"
                gutterBottom
                sx={{
                  mt: 3,
                  fontWeight: "bold",
                  color: "#1976d2",
                  fontFamily: "KaushanScript",
                }}
              >
                Travel Plan
              </Typography>
              <Box sx={{ pl: 2 }}>
                <Typography>
                  <strong>Onward - From:</strong>{" "}
                  {selectedGuest.onward_journey.placeFrom}
                </Typography>
                <Typography>
                  <strong>Onward - To:</strong>{" "}
                  {selectedGuest.onward_journey.placeTo}
                </Typography>
              </Box>

              {/* Return Journey */}
              <Typography
                variant="h6"
                gutterBottom
                sx={{
                  mt: 3,
                  fontWeight: "bold",
                  color: "#1976d2",
                  fontFamily: "KaushanScript",
                }}
              >
                Return Journey
              </Typography>
              <Box sx={{ pl: 2 }}>
                <Typography>
                  <strong>Return - From:</strong>{" "}
                  {selectedGuest.return_journey.placeFrom}
                </Typography>
                <Typography>
                  <strong>Return - To:</strong>{" "}
                  {selectedGuest.return_journey.placeTo}
                </Typography>
              </Box>

              {/* Total People */}
              <Typography
                variant="h6"
                gutterBottom
                sx={{ mt: 3, fontWeight: "bold", color: "#d32f2f" }}
              >
                Total People: {selectedGuest.total_people}
              </Typography>

              {/* Close Button */}
              <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 4 }}>
                <Button
                  variant="contained"
                  color="error"
                  onClick={handleCloseModal}
                  sx={{
                    textTransform: "none",
                    px: 3,
                    py: 1,
                    borderRadius: "8px",
                    fontWeight: "bold",
                    fontSize: "1rem",
                  }}
                >
                  Close
                </Button>
              </Box>
            </>
          )}
        </Box>
      </Modal>
    </Box>
  );
};
export default CoordinatorGuestList;
